/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/**
 * general phone number
 */
export const COMPANY_PHONE = "+49-6151-30289-0"

/**
 * general email address
 */
export const COMPANY_EMAIL = "info@teambits.de"

/**
 * URL to inquiry form
 */
export const COMPANY_INQUIRY_FORM = "teambits.de/kontakt"

/**
 * URL to online shop
 */
export const COMPANY_ONLINE_SHOP = "teambits.de/preise"

/**
 * URL to help site
 */
export const COMPANY_HELP_SITE = "teambits.de/hilfe"
